import cx from 'classnames';
import Badge from '@/vdp/Hero/Badge';
import { useIsDesktop } from '~/context/common/DeviceContext';

export default function ImageOverlay() {
  const isDesktop = useIsDesktop();

  return (
    <div
      className={cx(
        'pointer-events-none absolute inset-0 z-10 flex flex-col justify-between p-md sm:p-lg'
      )}
    >
      {isDesktop && (
        <div>
          <Badge />
        </div>
      )}
    </div>
  );
}
